import React from "react";
import styles from "./accomplishments.css";
import FontAwesome from "react-fontawesome";
import { AccompConfig } from "./AccompConfig";
import { FormattedMessage } from "react-intl";

class Accomplishments extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loadItems: this.getInitialItems() };
  }

  loadItems = action => {
    let itemCount =
      action === "LoadMore"
        ? AccompConfig.items.length
        : this.getInitialItems();
    this.setState({
      loadItems: itemCount
    });
  };

  getInitialItems = () => {
    let itemCount = window.outerWidth > 550 ? 6 : 3;
    return itemCount;
  };
  render() {
    let buttonLabelId =
      this.state.loadItems === AccompConfig.items.length
        ? "LoadLess"
        : "LoadMore";
    return (
      <div className={styles.container}>
        <h2 className="headerTitle">
          <FormattedMessage
            id="Accomplishments.title"
            defaultMessage="Recent accomplishments"
          />
        </h2>
        <ul className="prizesContainer">
          {AccompConfig.items.slice(0, this.state.loadItems).map((prize, i) => {
            return (
              <li key={i} className="prizeItem">
                <a href={prize.link} target="_blank">
                  <span
                    className="grayscale img"
                    style={{
                      backgroundImage:
                        "url(" +
                        process.env.REACT_APP_MEDIA_CONTENT +
                        "logos/" +
                        prize.logo +
                        ")"
                    }}
                    alt={prize.title}
                  />
                </a>
                <h4>
                  <FormattedMessage
                    id={"Accomplishments.title." + prize.institution}
                    defaultMessage="accomplishment title"
                  />
                </h4>
                <p className="prizeDate">
                  <FormattedMessage
                    id={"Accomplishments.date." + prize.institution}
                    defaultMessage=" "
                  />
                </p>
                <p className="prizeText">
                  <FormattedMessage
                    id={"Accomplishments.text." + prize.institution}
                    defaultMessage="accomplishment text"
                  />
                </p>
                <a
                  href={prize.link}
                  target="_blank"
                  key={prize.link}
                  className="ext"
                >
                  Read More{" "}
                  <FontAwesome style={{ paddingTop: 6 }} name="external-link" />
                </a>
              </li>
            );
          })}
        </ul>
        <button
          className="loadItems"
          onClick={() => this.loadItems(buttonLabelId)}
        >
          <FormattedMessage
            id={"General." + buttonLabelId}
            defaultMessage="Load more"
          />
        </button>
      </div>
    );
  }
}

export default Accomplishments;



// WEBPACK FOOTER //
// ./src/containers/accomplishments/Accomplishments.js